module.exports = __webpack_public_path__ + "assets/img/Bus-station.278c8517.svg";